<p-table
  [value]="items"
  [loading]="localLoading()"
>
  <ng-template #header>
    <tr>
      @for (column of columns; track $index) {
        <th
          [class]="column.align + ' text-sm'"
          [ngClass]="{ 'cursor-pointer': column.sortable }"
          (click)="column.sortable && sort(column.slug)"
        >
          {{ column.label }}
          @if (pageControl.orderField === column.slug) {
            @if (pageControl.order === order.ASC) {
              <i class="fa-solid fa-arrow-up"></i>
            }
            @if (pageControl.order === order.DESC) {
              <i class="fa-solid fa-arrow-down"></i>
            }
          }
        </th>
      }
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr>
      <td colspan="5" class="text-center">
        <div class="h-44 p-4 text-zinc-500">
          <ng-lottie [options]="emptyLottieOptions" />
          Nenhum registro encontrado.
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template #body let-item>
    <tr>
      <td>
        {{ item?.created_at | date: 'dd/MM/y' }}<br>
        {{ item?.created_at | date: 'HH:mm:ss' }}
      </td>

      <td>{{ item?.subject || '---' }}</td>

      <td>{{ item?.message || '---' }}</td>

      <td>
        @if (item.read_at) {
          <div
            class="cursor-pointer text-emerald-600"
            (click)="view.emit(item); $event.stopPropagation()"
            pTooltip="Visualizar Comunicado"
          >
            <i class="fa-solid fa-check-double"></i>
          </div>
        } @else {
          <p-button
            size="small"
            severity="secondary"
            (click)="view.emit(item); $event.stopPropagation()"
          >
            <i class="fa-solid fa-circle-check"></i>
            Confirmar Leitura
          </p-button>
        }
      </td>
    </tr>
  </ng-template>
 <ng-template #footer>
   <tr>
     <td colspan="5">
        <div class="w-full flex justify-end">
          <p-paginator
            (onPageChange)="onPageChange($event)"
            [rows]="pageControl.take"
            [totalRecords]="pageControl.itemCount"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            currentPageReportTemplate="{first} - {last} de {totalRecords}"
            appendTo="body"
          />
        </div>
     </td>
   </tr>
 </ng-template>
</p-table>
